
import { defineComponent, computed, ref, onMounted } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { ElMessage, ElMessageBox } from 'element-plus';

import { useAccountStore } from '@/store/account';
import { useMenuStore } from '@/store/menu';
import type { ICompanyInfoItem } from '@/api/account/type';

export default defineComponent({
  name: 'SelectCompany',
  setup() {
    const selectedCompanyId = ref('');

    const $route = useRoute();
    const $router = useRouter();
    const { query } = $route;

    const { account, setCurrentCompany, logout } = useAccountStore();
    const { getMenus, clearMenus } = useMenuStore();

    const companyInfoList = computed<ICompanyInfoItem[]>(() => {
      return account?.companyInfoList || [];
    });

    const visible = computed(() => {
      return companyInfoList.value?.length > 1;
    });

    const handleConfirm = async () => {
      if (!selectedCompanyId.value) {
        ElMessage.error('请选择租户');
        return;
      }
      const currentCompany = companyInfoList.value.find(it => it.companyId === selectedCompanyId.value);
      if (currentCompany) {
        setCurrentCompany(currentCompany);
        clearMenus();
        await getMenus();
      }

      const path = query.redirect as string | null;
      if (path) {
        $router.replace({ path: decodeURIComponent(path) });
      } else {
        $router.replace({
          name: 'Dashboard',
        });
      }
    };

    onMounted(() => {
      if (!visible.value) {
        ElMessageBox({
          title: '警告',
          message: '该账户暂无绑定租户，请联系管理员或检查账号是否正确。',
          confirmButtonText: '退出',
          showClose: false,
          showCancelButton: false,
          closeOnClickModal: false,
          closeOnPressEscape: false,
          type: 'warning',
          callback() {
            logout();
          },
        });
      }
    });

    return {
      selectedCompanyId,
      companyInfoList,
      handleConfirm,
      visible,
    };
  },
});
